import File from '../../services/file'
import * as types from '../mutationTypes'

let state = {
  error: null,
  success: null,
  filesByTask: [],
  files: [],
  totalFiles: 0,
  headers:
  [
    { text: 'Id', value: 'fileId' },
    { text: 'Category', value: 'category' },
    { text: 'File Name', value: 'fileName' },
    { text: 'Document Type', value: 'type' },
    { text: 'WO #', value: 'woTaskNumber' },
    { text: 'Task Status', value: 'taskStatus' },
    { text: 'Uploaded By', value: 'uploadedBy' },
    { text: 'Actions', value: 'action', sortable: false }
  ]
}

const getters = {
  error (state) {
    return state.error
  },
  success (state) {
    return state.success
  },
  filesByTask (state) {
    return state.filesByTask
  },
  total (state) {
    return state.totalFiles
  },
  files (state) {
    return state.files
  },
  headers () {
    return state.headers
  }
}

const actions = {
  async getZip ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let list = '&'
      data.docIds.forEach(id => {
        list += `docIds=${id}&`
      })

      data.imageIds.forEach(id => {
        list += `imageIds=${id}&`
      })

      data.changeIds.forEach(id => {
        list += `changeIds=${id}&`
      })

      let res = await File.getZip(list)

      if (res) {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', data.fileName)
        document.body.appendChild(link)
        link.click()
        commit(types.REQUEST_GET_ZIP_SUCCESS)
      }
    } catch (err) {
      commit(types.REQUEST_GET_ZIP_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async getTaskFiles ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await File.getByTask(data)

      if (res) {
        commit(types.REQUEST_GET_FILE_LIST_BY_TASK_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_FILE_LIST_BY_TASK_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async getFiles ({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await File.getAll(data)

      if (res) {
        commit(types.REQUEST_GET_FILE_LIST_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_FILE_LIST_ERROR, err.message)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  reset ({ commit }) {
    commit(types.CLEAR_ERROR_SUCCESS_MESSAGES)
  }
}

const mutations = {
  [types.REQUEST_GET_ZIP_SUCCESS] (state) {
    state.error = null
    state.success = 'Success'
  },
  [types.REQUEST_GET_ZIP_ERROR] (state, message) {
    state.error = message
    state.success = null
  },
  [types.REQUEST_GET_FILE_LIST_BY_TASK_SUCCESS] (state, data) {
    state.error = null
    state.success = 'Success'
    state.filesByTask = data
  },
  [types.REQUEST_GET_FILE_LIST_BY_TASK_ERROR] (state, message) {
    state.error = message
    state.success = null
    state.filesByTask = []
  },
  [types.REQUEST_GET_FILE_LIST_SUCCESS] (state, data) {
    state.error = null
    state.success = 'Success'
    state.files = data.list
    state.totalFiles = data.totalCount
  },
  [types.REQUEST_GET_FILE_LIST_ERROR] (state, message) {
    state.error = message
    state.success = null
    state.files = []
    state.totalFiles = 0
  },
  [types.CLEAR_ERROR_SUCCESS_MESSAGES] (state) {
    state.error = null
    state.success = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
